import { canUseDOM } from '@/app/common/utils/canUseDOM';
import { PLATFORM_DATA_EVENT_NAME, isPlatformDataEventTracked } from '@/app/common/tracking/platformDataUtils';

export const COOKIE_GO_EVENT = PLATFORM_DATA_EVENT_NAME.COOKIE_GO;

export const onCookieGo = (onFired: () => void): (() => void) => {
  if (!canUseDOM) return () => {};

  if (isPlatformDataEventTracked(COOKIE_GO_EVENT)) {
    onFired();
    return () => {};
  }

  window.addEventListener(COOKIE_GO_EVENT, onFired);
  return () => window.removeEventListener(COOKIE_GO_EVENT, onFired);
};
